import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const tokenizerComponent: ComponentDef = {
  id: 'tokenizer',
  name: 'Tokenizer',
  description: 'Text tokenization pipelines: BPE, WordPiece, SentencePiece, and Tiktoken.',
  category: 'function',
  params: [
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'vocab_size', label: 'Vocab size', type: 'number', default: 32000, min: 1000, max: 200000, step: 1000 },
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'variant', label: 'Variant', type: 'select', default: 'all', options: [{ label: 'All (comparison)', value: 'all' }, { label: 'BPE', value: 'bpe' }, { label: 'SentencePiece (Unigram)', value: 'sentencepiece' }, { label: 'WordPiece', value: 'wordpiece' }] }
  ],
  buildGraph: (params) => {
    const seq_len = Number(params.seq_len);
    const vocab_size = Number(params.vocab_size);
    const d_model = Number(params.d_model);
    const variant = params.variant;

    const g = new GraphBuilder();
    g.input('text', [seq_len]);

    if (variant === 'all') {
      g.scale('bpe', 'text', 'BPE');
      g.scale('wordpiece', 'text', 'WordPiece');
      g.scale('sentencepiece', 'text', 'SentencePiece');
      g.concat('ids', ['bpe', 'wordpiece', 'sentencepiece'], [seq_len * 3]);
      g.embedding('embed', 'ids', [vocab_size, d_model]);
      g.output('out', 'embed');
    } else if (variant === 'bpe') {
      g.scale('bytes', 'text', 'UTF-8 bytes');
      g.scale('merges', 'bytes', 'apply merges');
      g.embedding('embed', 'merges', [vocab_size, d_model]);
      g.output('out', 'embed');
    } else if (variant === 'sentencepiece') {
      g.scale('unigram', 'text', 'unigram LM');
      g.scale('subwords', 'unigram', 'Viterbi');
      g.embedding('embed', 'subwords', [vocab_size, d_model]);
      g.output('out', 'embed');
    } else {
      g.scale('prefix', 'text', '## prefix');
      g.scale('subwords', 'prefix', 'greedy match');
      g.embedding('embed', 'subwords', [vocab_size, d_model]);
      g.output('out', 'embed');
    }

    return g.build();
  }
};
